import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('layout', () => {
    // Sidebar
    const minimisedSidebar = ref(false)
    const mobileSidebarVisible = ref(false)
    const settings = ref({
        pageLoadingIndicator: false,
    })
    
    function toggleSidebarSize() {
        minimisedSidebar.value = !minimisedSidebar.value;
    }

    function openMobileSidebar() {
        mobileSidebarVisible.value = true;
    }

    function closeMobileSidebar() {
        mobileSidebarVisible.value = false;
    }

    function toggleMobileSidebar() {
        mobileSidebarVisible.value = !mobileSidebarVisible.value;
    }

    function pageLoader(payload) {
        if (payload.mode === "on") {
            settings.value.pageLoadingIndicator = true;
        } else if (payload.mode === "off") {
            settings.value.pageLoadingIndicator = false;
        } else if (payload.mode === "toggle") {
            settings.value.pageLoadingIndicator = !settings.value.pageLoadingIndicator;
        }
    }

    return {
        settings,
        minimisedSidebar,
        mobileSidebarVisible,
        toggleSidebarSize,
        openMobileSidebar,
        closeMobileSidebar,
        toggleMobileSidebar,
        pageLoader
    }
})
